import { Component, inject, Input, input, output, computed, signal } from '@angular/core';
import { FacetModel } from '../facet.model';
import { CardItemComponent } from 'app/shared/card/card-item/card-item.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { FacetAlias, UserFacet } from '../facet';
import { FacetIcons } from '../facet-icons.const';
import { HttpClient } from '@angular/common/http';
import { provideNgIconLoader, withCaching } from '@ng-icons/core';
import { FacetService } from '../facet.service';
import { DateConst } from '../../../shared/date.const';

@Component({
  selector: 'app-facet-grid-compact-container',
  standalone: true,
  imports: [CardItemComponent, IconComponent],
  templateUrl: './facet-grid-compact-container.component.html',
  styleUrls: ['./facet-grid-compact-container.component.scss'],
  providers: [
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
  host: {
    class: 'grid grid-cols-1 md:grid-cols-2 mb-4 gap-4 ng-star-inserted',
  },
})
export class FacetGridCompactContainerComponent {
  private facetService = inject(FacetService);

  @Input() facets: UserFacet[] | null = null;
  @Input() units: FacetModel[] | null = null;
  @Input() selectedUnits: FacetModel[] | null = null;

  previewMode = input(false);
  isCheckbox = input(false);
  isChevronIcon = input(false);
  isDeleteIcon = input(false);
  toggle = output<FacetModel>();
  delete = output<UserFacet>();
  allFacets = this.facetService.userNoChapterFacetTypes();
  edit = output<UserFacet>();

  // Функції, які створюють computed сигнали для конкретних об'єктів
  getUnitNames = (facet: UserFacet): string => {
    return facet && facet.units && facet.units.length
      ? facet.units.map((u) => u.title).join(', ')
      : '';
  }

  getUnitSubTitle = (unit: FacetModel): string => {
    const end = unit.end ? DateConst.getYear(unit.end) : 'now';
    return `${DateConst.getYear(unit.start)} - ${end}`;
  }

  getFacetIcon(alias: FacetAlias): string {
    return FacetIcons[alias];
  }

  isChecked(unit: FacetModel): boolean {
    return !!this.selectedUnits?.some((checked) => checked.id === unit.id);
  }
}
